import { IAppointmentType } from './appointment-type.interface';
export interface IOverridingChart {
    appointmentTypeId:number;
    appointmentType:IAppointmentType;
    l1Percent:number;
    icWeightage:number;
    poolWeightage:number;
}
